import React from 'react';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import styled from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import { useMediaDevice } from '../../Brands/hooks';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
export default function Smart({ pageType = 'normal' }) {
    const { locale } = getLocal();
    const { isH5, isPad } = useMediaDevice();

    const { t } = useLang('theProduct.Smart');
    const arr = [
        {
            title: t('item1_title'),
            desc: t('item1_desc'),
            type: 'img',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1747100117195/Smart%20Meter%20%C2%B7%20Monitor.png',
        },
        {
            title: t('item2_title'),
            desc: t('item2_desc'),
            type: 'img',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1747100117392/Smart%20Plug%20%C2%B7%20Switch.png',
        },
        {
            title: t('item3_title'),
            desc: t('item3_desc'),
            type: 'img',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1747100117032/Smart%20App%20%C2%B7%20Schedule.png',
        },
    ];
    // let;
    return (
        <div className={styled.Smart}>
            {isPad || isH5 ? (
                <>
                    <Swiper
                        className="smart-swiper"
                        modules={[Navigation]}
                        spaceBetween={16}
                        navigation
                        slidesPerView={'auto'}
                        initialSlide={0}
                        scrollbar={{
                            hide: false,
                            draggable: true,
                            dragSize: 24,
                            snapOnRelease: true,
                        }}
                    >
                        {arr.map((item: any, index: number) => (
                            <SwiperSlide className="smart-slide-item" key={index}>
                                <div className="smart-item">
                                    <div className="img">
                                        <EcoImg pc={item.h5} />
                                    </div>
                                    <div className="msg">
                                        <div className="title">{item.title}</div>
                                        <div className="desc">{item.desc}</div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </>
            ) : (
                <div className="smart-box">
                    <div className="smart-item">
                        <div className="img">
                            <EcoImg
                                h5="https://websiteoss.ecoflow.com/upload/image/1747100117195/Smart%20Meter%20%C2%B7%20Monitor.png"
                                pad="https://websiteoss.ecoflow.com/upload/image/1747100117195/Smart%20Meter%20%C2%B7%20Monitor.png"
                                pc="https://websiteoss.ecoflow.com/upload/image/1747100117195/Smart%20Meter%20%C2%B7%20Monitor.png"
                            />
                        </div>
                        <div className="msg">
                            <div className="title">{t('item1_title')}</div>
                            <div className="desc">{t('item1_desc')}</div>
                        </div>
                    </div>
                    <div className="smart-item">
                        <div className="img">
                            <EcoImg
                                h5="https://websiteoss.ecoflow.com/upload/image/1747100117392/Smart%20Plug%20%C2%B7%20Switch.png"
                                pad="https://websiteoss.ecoflow.com/upload/image/1747100117392/Smart%20Plug%20%C2%B7%20Switch.png"
                                pc="https://websiteoss.ecoflow.com/upload/image/1747100117392/Smart%20Plug%20%C2%B7%20Switch.png"
                            />
                        </div>
                        <div className="msg">
                            <div className="title">{t('item2_title')}</div>
                            <div className="desc">{t('item2_desc')}</div>
                        </div>
                    </div>
                    <div className="smart-item">
                        <div className="img">
                            <EcoImg
                                h5="https://websiteoss.ecoflow.com/upload/image/1747100117032/Smart%20App%20%C2%B7%20Schedule.png"
                                pad="https://websiteoss.ecoflow.com/upload/image/1747100117032/Smart%20App%20%C2%B7%20Schedule.png"
                                pc="https://websiteoss.ecoflow.com/upload/image/1747100117032/Smart%20App%20%C2%B7%20Schedule.png"
                            />
                        </div>
                        <div className="msg">
                            <div className="title">{t('item3_title')}</div>
                            <div className="desc">{t('item3_desc')}</div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
